import { Quotation } from '../../../../../sale/model';
import { icons, searchQuotationInfo } from './search-quote.config';
export const associatedQuotes = {
  checkbox: true,
  iconsOfActions: icons,
  alterColumns: true,
  hasDisabledCheckBoxItem: (row: Quotation): boolean => {
    return row.quotationInfo.cancellable ? false : true;
  },
  show: 'Aplicar los filtros para ver los resultados',
  columns: searchQuotationInfo.columns
};